import { MNIDashboardWidgetPreferences } from '@/core/preferences/export';
import { Layouts } from 'react-grid-layout';
import {
  faArrowUpRightDots,
  faGlobe,
  faMagnifyingGlassChart,
  faOilWell,
} from '@fortawesome/free-solid-svg-icons';
import { faCreditCard, faHandshake } from '@fortawesome/free-regular-svg-icons';

export interface SuggestedLayout {
  name: string;
  description: string;
  layouts: Layouts;
  order: number;
  widgetPreferences: MNIDashboardWidgetPreferences;
  icon: any;
}

const suggestedLayouts: SuggestedLayout[] = [
  {
    order: 4,
    icon: faOilWell,
    name: 'Commodities Focused',
    description: 'Everything about Energy, all the time.',
    layouts: {
      lg: [
        {
          h: 4,
          i: '/pinned-series/mni-section:d-carbon-market-research',
          w: 3,
          x: 13,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:2255207223',
          w: 3,
          x: 7,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:2148748890',
          w: 3,
          x: 7,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/energy-bullets',
          w: 7,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:600166007',
          w: 3,
          x: 13,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:561375749',
          w: 3,
          x: 10,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:d-political-drivers-for-energy',
          w: 3,
          x: 10,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:d-us-commodities-research',
          w: 3,
          x: 7,
          y: 8,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:d-eu-energy-markets',
          w: 3,
          x: 10,
          y: 8,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:d-north-america-gas-fundamentals',
          w: 3,
          x: 13,
          y: 8,
          moved: false,
          static: false,
        },
      ],
    },
    widgetPreferences: {
      '/bullets/energy-bullets': {
        includedSections: ['gas-bullets', 'oil-bullets', 'power-bot', 'us-oil', 'us-gas-bullets'],
      },
      '/pinned-series/mni-section:500163514': {
        color: 'note-green',
      },
      '/pinned-series/mni-section:518382770': {
        color: 'note-green',
      },
      '/pinned-series/mni-section:561375749': {
        color: 'note-yellow',
      },
      '/pinned-series/mni-section:600166007': {
        color: 'note-green',
      },
      '/pinned-series/mni-section:2148748890': {
        color: 'note-green',
        title: 'Commodities Weekly Analysis',
      },
      '/pinned-series/mni-section:2255207223': {
        color: 'note-blue',
        title: 'NatGas & LNG Analysis',
      },
      '/pinned-series/mni-section:d-political-drivers-for-energy': {
        color: 'note-orange',
      },
      '/pinned-series/mni-section:d-us-commodities-research': {
        color: 'note-green',
        title: 'US Commodities Research',
      },
      '/pinned-series/mni-section:d-north-america-gas-fundamentals': {
        color: 'note-orange',
      },
    },
  },
  {
    order: 5,
    icon: faCreditCard,
    name: 'Credit Focused',
    description: 'All of the credit markets together!',
    layouts: {
      lg: [
        {
          h: 5,
          i: '/pinned-series/mni-section:2243823041',
          w: 4,
          x: 12,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/calendar',
          w: 5,
          x: 7,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 5,
          i: '/pinned-series/mni-section:d-em-sovereign-analysis',
          w: 4,
          x: 8,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 5,
          i: '/pinned-series/mni-section:d-emerging-market-credit-weekly',
          w: 4,
          x: 12,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:d-us-weekly-credit-analysis',
          w: 5,
          x: 7,
          y: 9,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/events/fomc-meeting-calendar',
          w: 4,
          x: 12,
          y: 9,
          moved: false,
          static: false,
        },
        {
          h: 13,
          i: '/bullets/credit-bullets',
          w: 7,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
    },
    widgetPreferences: {
      '/calendar': {},
      '/bullets/credit-bullets': {
        includedSections: [
          'us-credit-bullets',
          'us-hy-credit-bullets',
          'eu-credit-bullets',
          'eu-fi-bullets',
          'em-credit-bullets',
        ],
      },
      '/events/fomc-meeting-calendar': {},
      '/pinned-series/mni-section:2243823041': {
        color: 'note-orange',
        title: 'EU Credit Analysis',
      },
      '/pinned-series/mni-section:d-us-weekly-credit-analysis': {
        color: 'note-green',
        title: 'US IG Credit Analysis',
      },
      '/pinned-series/mni-section:d-emerging-market-credit-weekly': {
        color: 'note-blue',
        title: 'EM Credit Analysis',
      },
      '/pinned-series/mni-section:d-em-sovereign-analysis': {
        color: 'note-yellow',
        title: 'EM Sovereign Analysis',
      },
    },
  },
  {
    order: 3,
    name: 'Emerging Markets',
    icon: faArrowUpRightDots,
    description: 'EM Markets, EM Credit and EM Policy, everything in one place!',
    layouts: {
      lg: [
        {
          h: 4,
          i: '/pinned-series/mni-section:538093858',
          w: 4,
          x: 12,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/calendar',
          w: 4,
          x: 12,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/mainwire',
          w: 4,
          x: 8,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/em-bullets',
          w: 4,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/credit-bullets',
          w: 4,
          x: 4,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      md: [
        {
          h: 4,
          i: '/pinned-series/mni-section:538093858',
          w: 4,
          x: 4,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/calendar',
          w: 4,
          x: 8,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/bullets/mainwire',
          w: 4,
          x: 8,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/em-bullets',
          w: 4,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/bullets/credit-bullets',
          w: 4,
          x: 4,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      sm: [
        {
          h: 4,
          i: '/pinned-series/mni-section:538093858',
          w: 4,
          x: 0,
          y: 8,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/calendar',
          w: 4,
          x: 4,
          y: 8,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/bullets/mainwire',
          w: 4,
          x: 4,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/em-bullets',
          w: 4,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/bullets/credit-bullets',
          w: 4,
          x: 4,
          y: 4,
          moved: false,
          static: false,
        },
      ],
    },
    widgetPreferences: {
      '/calendar': {},
      '/bullets/mainwire': {
        title: 'EM Policy',
        includedSections: ['em-mainwire'],
      },
      '/bullets/em-bullets': {
        includedSections: ['em-bullets'],
      },
      '/bullets/credit-bullets': {
        title: 'EM Credit',
        includedSections: ['em-credit-bullets'],
      },
      '/pinned-series/mni-section:538093858': {
        color: 'note-blue',
        title: 'LatAm Bank - Preview',
      },
    },
  },
  {
    order: 2,
    name: 'FX/FI Markets',
    icon: faMagnifyingGlassChart,
    description: 'Everything about G10 markets together!',
    layouts: {
      lg: [
        {
          h: 4,
          i: '/pinned-series/mni-section:d-egb-supply-daily',
          w: 5,
          x: 11,
          y: 8,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:600166007',
          w: 5,
          x: 11,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:504988115',
          w: 5,
          x: 11,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/calendar',
          w: 6,
          x: 5,
          y: 6,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/bullets/mainwire',
          w: 6,
          x: 5,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 12,
          i: '/bullets/all-bullets',
          w: 5,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      md: [
        {
          h: 4,
          i: '/pinned-series/mni-section:d-egb-supply-daily',
          w: 3,
          x: 6,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:600166007',
          w: 3,
          x: 3,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:504988115',
          w: 3,
          x: 0,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/calendar',
          w: 3,
          x: 9,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/bullets/mainwire',
          w: 6,
          x: 6,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/bullets/all-bullets',
          w: 6,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
    },
    widgetPreferences: {
      '/calendar': {},
      '/bullets/mainwire': {
        includedSections: ['mainwire', 'em-mainwire'],
      },
      '/bullets/all-bullets': {
        includedSections: [
          'fx-bullets',
          'fi-bullets',
          'em-bullets',
          'eu-credit-bullets',
          'us-credit-bullets',
          'us-hy-credit-bullets',
          'em-credit-bullets',
          'oil-bullets',
          'power-bot',
          'gas-bullets',
        ],
      },
      '/pinned-series/mni-section:504988115': {
        title: 'Fed - Preview',
      },
      '/pinned-series/mni-section:600166007': {
        title: 'Political Risk - US Daily Brief',
      },
    },
  },
  {
    order: 1,
    name: 'Global Markets and Policy',
    icon: faGlobe,
    description: 'You care about everything? This is your space, to keep yourself up to date!',
    layouts: {
      lg: [
        {
          h: 5,
          i: '/pinned-series/mni-section:d-egb-supply-daily',
          w: 5,
          x: 11,
          y: 6,
          moved: false,
          static: false,
        },
        {
          h: 5,
          i: '/pinned-series/mni-section:504988115',
          w: 5,
          x: 6,
          y: 6,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/calendar',
          w: 5,
          x: 11,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/bullets/mainwire',
          w: 5,
          x: 6,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 11,
          i: '/bullets/all-bullets',
          w: 6,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      md: [
        {
          h: 3,
          i: '/pinned-series/mni-section:d-egb-supply-daily',
          w: 4,
          x: 8,
          y: 5,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/pinned-series/mni-section:504988115',
          w: 4,
          x: 4,
          y: 5,
          moved: false,
          static: false,
        },
        {
          h: 5,
          i: '/calendar',
          w: 4,
          x: 8,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 5,
          i: '/bullets/mainwire',
          w: 4,
          x: 4,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/all-bullets',
          w: 4,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      sm: [
        {
          h: 3,
          i: '/pinned-series/mni-section:d-egb-supply-daily',
          w: 2,
          x: 6,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/pinned-series/mni-section:504988115',
          w: 2,
          x: 6,
          y: 3,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/calendar',
          w: 3,
          x: 3,
          y: 3,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/bullets/mainwire',
          w: 3,
          x: 3,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/bullets/all-bullets',
          w: 3,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
    },
    widgetPreferences: {
      '/calendar': {},
      '/bullets/mainwire': {
        includedSections: ['mainwire', 'em-mainwire'],
      },
      '/bullets/all-bullets': {
        includedSections: [
          'fx-bullets',
          'fi-bullets',
          'em-bullets',
          'eu-credit-bullets',
          'us-credit-bullets',
          'us-hy-credit-bullets',
          'em-credit-bullets',
          'oil-bullets',
          'power-bot',
          'gas-bullets',
        ],
      },
      '/pinned-series/mni-section:504988115': {
        title: 'Fed - Preview',
      },
    },
  },
  {
    order: 6,
    name: 'Corporate Dashboard',
    icon: faHandshake,
    description: 'Are you just interested in Global Macro? This is your suggested dashboard!',
    layouts: {
      lg: [
        {
          h: 4,
          i: '/pinned-series/mni-section:551192114',
          w: 4,
          x: 12,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:2257094548',
          w: 4,
          x: 12,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/calendar',
          w: 5,
          x: 7,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 8,
          i: '/bullets/gm-bullets',
          w: 7,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      md: [
        {
          h: 4,
          i: '/pinned-series/mni-section:551192114',
          w: 6,
          x: 6,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 5,
          i: '/pinned-series/mni-section:2257094548',
          w: 6,
          x: 6,
          y: 4,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/calendar',
          w: 6,
          x: 0,
          y: 6,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/bullets/gm-bullets',
          w: 6,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
      sm: [
        {
          h: 5,
          i: '/pinned-series/mni-section:551192114',
          w: 4,
          x: 4,
          y: 0,
          moved: false,
          static: false,
        },
        {
          h: 4,
          i: '/pinned-series/mni-section:2257094548',
          w: 4,
          x: 4,
          y: 5,
          moved: false,
          static: false,
        },
        {
          h: 3,
          i: '/calendar',
          w: 4,
          x: 0,
          y: 6,
          moved: false,
          static: false,
        },
        {
          h: 6,
          i: '/bullets/gm-bullets',
          w: 4,
          x: 0,
          y: 0,
          moved: false,
          static: false,
        },
      ],
    },
    widgetPreferences: {
      '/calendar': {},
      '/bullets/gm-bullets': {
        includedSections: ['dm-gm-bullets', 'em-gm-bullets'],
      },
      '/pinned-series/mni-section:551192114': {
        title: 'Inflation Insight',
      },
      '/pinned-series/mni-section:2257094548': {
        title: 'Global Macro Weekly',
      },
    },
  },
];

export default suggestedLayouts;
